exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".receipt-print-config[data-v-9e43a8fc]{width:100%;overflow:hidden;background:#fff}.receipt-print-iframe[data-v-9e43a8fc]{display:block;width:100%;height:100%;border:0}", ""]);

// exports
